import React from "react";

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     routeType: "public"||"admin"||"adminOrEmployee",
//     component: React.lazy(() => import("../pages/auth/Login")),
//     layout: "auth"||false,
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         routeType: "public"||"admin"||"adminOrEmployee",
//         component: React.lazy(() => import("../pages/employees/Manage")),
//         layout: "auth"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

const publicRoute = (data) => {
  return [
    {
      path: "/",
      routeType: "public",
      component: React.lazy(() => import("../pages/landing/LandingPage")),
      layout: false,
      title: "log",
    },
    {
      path: "/login",
      routeType: "public",
      component: React.lazy(() => import("../pages/auth/Login")),
      layout: false,
      title: "login",
    },
    {
      path: "/setup-password",
      routeType: "public",
      component: React.lazy(() => import("../pages/auth/SetupPassword")),
      layout: false,
      title: "setup-password",
    },
    {
      path: "/reset-password",
      routeType: "public",
      component: React.lazy(() => import("../pages/auth/ResetPassword")),
      layout: false,
      title: "reset-password",
    },
    {
      path: "/set-password/:token",
      routeType: "public",
      component: React.lazy(() => import("../pages/auth/SetPassword")),
      layout: false,
      title: "set-password",
    },
    {
      path: "/accept-employee",
      routeType: "public",
      component: React.lazy(() => import("../pages/auth/AcceptEmployee")),
      layout: false,
      title: "accept-employee",
    },
  ];
};

const protectedRoute = (data) => {
  return [
    {
      path: "/dashboard",
      component: React.lazy(() => import("../components/HomePage")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/user-management",
      routeType: "admin",
      component: React.lazy(() => import("../pages/admin/UserManagement")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/user-details/:id",
      routeType: "admin",
      component: React.lazy(() => import("../pages/admin/UserDetails")),
      layout: "auth",
      title: "user-details",
    },
    {
      path: "/user/:id",
      routeType: "admin",
      component: React.lazy(() => import("../pages/UserDashboardPage")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/settings",
      routeType: "admin",
      component: React.lazy(() => import("../pages/admin/Settings")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/bonus-evaluation/:employeeId",
      component: React.lazy(() => import("../pages/BonusEvaluation/index")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/bonus-evaluation-demo/:employeeId",
      component: React.lazy(() => import("../pages/demo/BonusEvaluation")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/templates",
      routeType: "adminOrEmployee",
      component: React.lazy(() => import("../pages/admin/Template")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/templates/create",
      routeType: "adminOrEmployee",
      component: React.lazy(() => import("../components/TemplateCreation")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/templates/edit/:id",
      routeType: "adminOrEmployee",
      component: React.lazy(() => import("../components/TemplateCreation")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/templates/:id/settings",
      component: React.lazy(() =>
        import("../components/bonus/TemplateSettings")
      ),
      layout: "auth",
      title: "log",
    },
    {
      path: "/bonus-evaluations/:id/edit",
      component: React.lazy(() => import("../pages/EditBonusEvaluationPage")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/reports",
      component: React.lazy(() => import("../pages/BonusReportPreviewPage")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/test",
      component: React.lazy(() => import("../components/Test")),
      layout: "auth",
      title: "log",
    },
    {
      path: "/testing-bonus",
      component: React.lazy(() =>
        import("../components/TestingBonusEvaluation")
      ),
      layout: "auth",
      title: "log",
    },
  ];
};

export const routerData = (userData) => [
  ...publicRoute(userData),
  ...protectedRoute(userData),
];
